import { ymdFormat } from '@/utils/datetime'

const state = () => ({
  data: {
    detailData: []
  }
})

const mutations = {
  CHANGE__DATA: (state, data) => {
    const { detailData } = data
    state.data = {
      detailData: detailData
        ? detailData.map((v) => ({
            ...v,
            purchaseNumber: v.applyNumber,
            purchaseRemark: v.note
          }))
        : [],
      purchaseTime: ymdFormat(new Date()),
      documentType: 1
    }
  },
  CLEAR__DATA: (state) => {
    state.data = {
      detailData: []
    }
  }
}

const actions = {
  async handleWarehouseMateApplyData({ commit }, data) {
    commit('CHANGE__DATA', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
